<div class="node">
	<input type="checkbox" [(ngModel)]="isChecked"/>
	<ng-container *ngTemplateOutlet="template; context: nodeContext"></ng-container>
	<div *ngIf="node.children" class="padding-child-node">
		<internal-tree-node *ngFor="let child of node.children" [node]="child" [template]="template">
		</internal-tree-node>
	</div>
</div>